<template>
  <div
    ref="cardRef"
    class="app-product-aid-swipe-card"
    :class="{
      'app-product-aid-swipe-card--active': isActive,
      'app-product-aid-swipe-card--next': isNext,
      'app-product-aid-swipe-card--hidden': isHidden,
    }"
    :style
  >
    <!-- Rendered only inside the preload window so off-screen cards don't fetch (see AppProductAidCardStack) -->
    <NuxtImg
      v-if="shouldLoadImage"
      :src="image"
      :alt
      provider="storyblok"
      :height="getImageDimensionsFromStoryblokSrc(image).height"
      :width="getImageDimensionsFromStoryblokSrc(image).width"
      :fetchpriority="isActive ? 'high' : 'low'"
      class="app-product-aid-swipe-card__image"
    />

    <AppProductAidSwipeIndicator v-if="isActive" type="like" :opacity="likeOpacity" />
    <AppProductAidSwipeIndicator v-if="isActive" type="dislike" :opacity="dislikeOpacity" />
  </div>
</template>

<script setup lang="ts">
  const {
    image,
    alt = '',
    isActive = false,
    isNext = false,
    isHidden = false,
    shouldLoadImage = true,
    style = {},
    likeOpacity = 0,
    dislikeOpacity = 0,
  } = defineProps<{
    image: string;
    alt?: string;
    isActive?: boolean;
    isNext?: boolean;
    isHidden?: boolean;
    shouldLoadImage?: boolean;
    style?: Record<string, string | number>;
    likeOpacity?: number;
    dislikeOpacity?: number;
  }>();

  const el = useTemplateRef('cardRef');

  defineExpose({
    el,
  });
</script>

<style lang="postcss" scoped>
  .app-product-aid-swipe-card {
    will-change: transform;
    cursor: grab;
    user-select: none;

    position: absolute;
    inset: 0;
    transform-origin: center bottom;

    overflow: hidden;

    border: 4px solid var(--colors-black);
    border-radius: 16px;

    background: #fff;

    &:active {
      cursor: grabbing;
    }

    &--next {
      background: #a855f7;
    }

    &--hidden {
      display: none;
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
</style>
